import AddressCard from './address-card';

export default AddressCard;
